import Vue from 'PublicJs/vue-bootstrap';
import MailingLists from 'PublicJs/MailingLists/components/MailingLists';
import { initPhoneNumberValidation } from 'PublicJs/Components/Generic/PhoneNumberValidation';
import App from 'PublicJs/App';

initPhoneNumberValidation('#company-tel1', App.countryCode);

new Vue({
	el: '#mailing-lists-app',
	components: {
		MailingLists
	}
});
